import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import config from '../../../config/config';
import { STATUS_PAID, STATUS_PENDING_PAYMENT } from 'utils/orderStatuses';

interface StatusPendingAdditionalInformationProps {
  status: string;
  pendingReason: string | null;
  dueDate: string | null;
  displayTickets: boolean;
}

const StatusPendingAdditionalInformation: React.FC<
  StatusPendingAdditionalInformationProps
> = ({ status, pendingReason, dueDate, displayTickets }) => {
  const { t } = useTranslation();
  const detailsWhenThereIsNoPendingReasonAndStatusIsPending = [
    t('orderConfirmationPage.detailOne'),
    t('orderConfirmationPage.detailTwo'),
    t('orderConfirmationPage.detailThree', { dueDate }),
  ];
  if (!displayTickets) {
    detailsWhenThereIsNoPendingReasonAndStatusIsPending[1] = t(
      'orderConfirmationPage.detailTwoWithoutTicketsMention',
    );
  }
  const detailsWhenTheReasonIsVies = [
    t('orderConfirmationPage.viesDidNotRespond', {
      vies_url: config.orderConfirmationPage.viesLink,
    }),
    t('orderConfirmationPage.messageWhenOrderIsInPendingAndViesDidNotRespond'),
  ];
  const detailsWhenTheReasonIsViesAndStatusIsPaid = [
    t('orderConfirmationPage.viesDidNotRespond', {
      vies_url: config.orderConfirmationPage.viesLink,
    }),
    t('orderConfirmationPage.messageWhenOrderIsInPaidAndViesDidNotRespond'),
  ];

  return (
    <>
      <p className="p1-medium">{t('orderConfirmationPage.moreDetails')}</p>
      <ul className="list-disc pl-[16px]">
        {status === STATUS_PENDING_PAYMENT &&
          pendingReason === null &&
          detailsWhenThereIsNoPendingReasonAndStatusIsPending.map(detail => (
            <li
              key={detail}
              className="p2-regular mt-[4px]"
              dangerouslySetInnerHTML={{ __html: detail }}
            />
          ))}
        {status === STATUS_PENDING_PAYMENT &&
          pendingReason === 'vies' &&
          detailsWhenTheReasonIsVies.map(detail => (
            <li
              key={detail}
              className="p2-regular mt-[4px]"
              dangerouslySetInnerHTML={{ __html: detail }}
            />
          ))}
        {status === STATUS_PAID &&
          pendingReason === 'vies' &&
          detailsWhenTheReasonIsViesAndStatusIsPaid.map(detail => (
            <li
              key={detail}
              className="p2-regular mt-[4px]"
              dangerouslySetInnerHTML={{ __html: detail }}
            />
          ))}
      </ul>
    </>
  );
};

export default memo(StatusPendingAdditionalInformation);
